module.exports = __webpack_public_path__ + "img/mega.2aa6291.jpg";